import React, { useRef } from 'react';
import { Box, Modal, Backdrop, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import QRCode from 'qrcode.react';
import { CopyIcon, DownloadIcon, EyeIcon } from './Icons';
import Logo from '../../../assets/img/brand/logo-blue.png';
import html2canvas from 'html2canvas';
import { copierHelper } from 'utils';
import { toast } from 'react-toastify';

const modalStyle = {
    width: '94%',
    maxWidth: 400,
    bgcolor: '#fff',
    py: 4,
    px: 3,
    borderRadius: 10,
    textAlign: 'center',
};

export default function ShareModal({ open, handleClose, userId, user }) {
    const targetRef = useRef(null);
    const [isDownloading, setIsDownloading] = React.useState(false);

    const downloadQr = async () => {
        if (!targetRef.current) return;

        try {
            setIsDownloading(true);
            await document.fonts.ready; // Ensure custom fonts are loaded

            const canvas = await html2canvas(targetRef.current, {
                useCORS: true,
                letterRendering: true,
                scale: 2,
                backgroundColor: null, // 👈 This enables transparency
            });

            const imgData = canvas.toDataURL('image/png');

            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'business-profile.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('PNG generation failed:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    const preview_link =
        window.location.hostname === 'app.smartcomplyapp.com' || window.location.hostname === 'app.smartcomply.com'
            ? `https://app.smartcomplyapp.com/business-profile/view/${userId}`
            : window.location.hostname === 'localhost'
            ? `http://localhost:3000/business-profile/view/${userId}`
            : `https://development.smartcomplyapp.com/business-profile/view/${userId}`;

    if (!preview_link) return;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: {
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    },
                },
            }}
        >
            <>
                <div className="absolute left-[-200%]">
                    <div
                        ref={targetRef}
                        className="w-[400px] h-[372px] bg-white rounded-3xl shadow-lg flex flex-col items-center justify-center"
                    >
                        <div className="text-gray-800">
                            <h1
                                className="text-2xl font-bold text-center capitalize font-poppins"
                                style={{
                                    fontFamily: 'Poppins, sans-serif',
                                }}
                            >
                                {(user?.first_name || '--') + ' ' + (user?.last_name || '--')}
                            </h1>
                            {user?.position && (
                                <p className="text-center text-lg mb-2 font-semibold capitalize">
                                    {user?.position || '--'}
                                </p>
                            )}
                        </div>
                        <div className="my-4">
                            <QRCode id="qr" value={preview_link} renderAs="svg" size={170} />
                        </div>
                        <img src={Logo} className="w-[180px] h-auto" />
                    </div>
                </div>
                <Box
                    sx={{
                        ...modalStyle,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#475569',
                    }}
                >
                    <div className="text-gray-800">
                        <h1 className="text-2xl font-bold text-center capitalize">
                            {(user?.first_name || '--') + ' ' + (user?.last_name || '--')}
                        </h1>
                        <p className="text-center text-lg mb-2 font-semibold capitalize">{user?.position || '--'}</p>
                    </div>

                    <QRCode id="qr" value={preview_link} renderAs="svg" size={190} style={{ margin: '2rem auto' }} />

                    <List sx={{ mt: 3, fontWeight: 500 }}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => copierHelper(preview_link, toast)}>
                                <span className="text-gray-500 text-sm inline-block mr-2 ">
                                    <CopyIcon />
                                </span>
                                <ListItemText className="[&_span]:!font-semibold" primary={'Copy link to clipboard'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={downloadQr} disabled={isDownloading} loading={isDownloading}>
                                <span className="text-gray-500 text-sm inline-block mr-2 ">
                                    <DownloadIcon />
                                </span>
                                <ListItemText className="[&_span]:!font-semibold" primary={'Download QR Code'} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton href={preview_link}>
                                <span className="text-gray-500 text-sm inline-block mr-2 ">
                                    <EyeIcon />
                                </span>
                                <ListItemText
                                    className="[&_span]:!font-semibold [&_span]:!text-gray-600"
                                    primary={'See E-Business Card preview'}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </>
        </Modal>
    );
}
